if (!Enum) {
    var Enum = {};
}

Enum.DOSAGE_TYPE = {
    MORNING: 'MORNING',
    AFTERNOON: 'AFTERNOON',
    EVENING: 'EVENING'
};

Object.freeze(Enum.DOSAGE_TYPE);